'use strict';

module.exports = Object.freeze([
  'Brand Marketing',
  'Product Marketing',
  'New Product Marketing',
  'Specific Product Marketing',
  'Discount Offers',
  'Partner Offers',
  'Customer Research',
  'Newsletter',
  'Membership',
  'Volunteering',
  'Fundraising',
  'Sharing Data within Group',
  'Sharing Data with Partners',
  'Automated Decision Making',
  'Location Tracking',
  'Online Tracking',
  'Cross-Border Transfers',
]);
